/* eslint-disable max-len */
import React from 'react';

export const MarketingBubbles = () => {
  return (
    <svg viewBox="0 0 317 481">
      <g>
        <g>
          <circle cx="166.07" cy="24.41" r="22.06" fill="#15203d" />
          <path
            d="M166.07,2.85a21.56,21.56,0,1,1-21.56,21.56h0A21.56,21.56,0,0,1,166.07,2.85m0-1a22.56,22.56,0,1,0,22.56,22.56h0A22.56,22.56,0,0,0,166.07,1.85Z"
            fill="#fff"
          />
        </g>
        <g>
          <circle cx="66.18" cy="293.03" r="13.5" fill="#15203d" />
          <path
            d="M66.18,279.78A13.25,13.25,0,1,1,52.93,293a13.25,13.25,0,0,1,13.25-13.25h0m0-.5A13.75,13.75,0,1,0,79.93,293h0A13.75,13.75,0,0,0,66.18,279.28Z"
            fill="#fff"
          />
        </g>
        <g>
          <circle cx="38.32" cy="176.26" r="36.25" fill="#15203d" />
          <path
            d="M38.32,141A35.25,35.25,0,1,1,3.07,176.26h0A35.25,35.25,0,0,1,38.32,141m0-2a37.25,37.25,0,1,0,37.25,37.25A37.25,37.25,0,0,0,38.32,139Z"
            fill="#fff"
          />
        </g>
        <g>
          <circle cx="246.32" cy="363.1" r="36.25" fill="#15203d" />
          <path
            d="M246.32,327.85a35.25,35.25,0,1,1-35.25,35.25,35.25,35.25,0,0,1,35.25-35.25h0m0-2a37.25,37.25,0,1,0,37.25,37.25A37.25,37.25,0,0,0,246.32,325.85Z"
            fill="#fff"
          />
        </g>
        <g>
          <circle cx="254.39" cy="84.19" r="50.33" fill="#15203d" />
          <path
            d="M254.4,34.85a49.33,49.33,0,1,1-49.33,49.32A49.33,49.33,0,0,1,254.4,34.85m0-2a51.34,51.34,0,1,0,51.34,51.34h0A51.35,51.35,0,0,0,254.4,32.85Z"
            fill="#fff"
          />
        </g>
        <path
          d="M64.24,348.38a77.46,77.46,0,0,1,109.05,0,76.27,76.27,0,0,1,.49,107.86l-.49.49a77.46,77.46,0,0,1-109,0,76.27,76.27,0,0,1-.49-107.86Z"
          fill="#fcb727"
        />
        <path
          d="M184.24,207.38a77.46,77.46,0,0,1,109.05,0,76.27,76.27,0,0,1,.49,107.86l-.49.49a77.46,77.46,0,0,1-109,0,76.27,76.27,0,0,1-.49-107.86Z"
          fill="#043a7d"
        />
        <path
          d="M69.22,52.4a87.42,87.42,0,0,1,123.09,0,86.08,86.08,0,0,1,.55,121.75c-.18.19-.36.37-.55.55a87.43,87.43,0,0,1-123.09,0A86.1,86.1,0,0,1,68.67,53Z"
          fill="#0776fc"
        />
        <g>
          <circle cx="188.95" cy="194.82" r="22.06" fill="#fff" />
          <g style={{ isolation: 'isolate' }}>
            <g style={{ isolation: 'isolate' }}>
              <path d="M186.27,203.5v-6.2H180v-3.63h6.24v-6.23h3.62v6.23h6.21v3.63h-6.21v6.2Z" fill="#15203d" />
            </g>
          </g>
        </g>
        <g>
          <circle cx="174.63" cy="329.41" r="22.06" fill="#fff" />
          <g style={{ isolation: 'isolate' }}>
            <g style={{ isolation: 'isolate' }}>
              <path d="M183.1,328.05l-16.07,0v-3.62l16.07,0Zm0,7.78H167v-3.62H183.1Z" fill="#15203d" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
